<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="false">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex items-center w-full p-4 pl-6">
            <!-- Logo -->
            <div class="flex items-center justify-center">
                <a href="/">
                <img
                    class="w-8"
                    src="assets/images/logo/logo.png">
                </a>
            </div>
            <!-- Components -->
            <div class="flex items-center ml-auto">
                <user [showAvatar]="false"></user>
            </div>
        </div>
        <!-- User -->
        <div class="flex flex-col items-center w-full p-4">
            <!-- <div class="relative w-24 h-24">
                <img
                    class="w-full h-full rounded-full"
                    *ngIf="user.avatar"
                    [src]="user.avatar"
                    alt="User avatar">
                <mat-icon
                    class="icon-size-24"
                    *ngIf="!user.avatar"
                    [svgIcon]="'heroicons_solid:user-circle'"></mat-icon>
            </div> -->
            <div id="user-info" class="flex flex-col items-center justify-center w-full mt-6">
                <div id="user-name" class="w-full whitespace-nowrap text-ellipsis overflow-hidden text-center leading-normal font-medium">
                    {{user.name}}
                </div>
                <div id="user-email" class="w-full mt-0.5 whitespace-nowrap text-ellipsis overflow-hidden text-center text-md leading-normal font-medium text-secondary">
                    {{user.email}}
                </div>
                <div *ngIf="isPrimaryContact()" id="user-primary-contact" class="w-full mt-0.5 whitespace-nowrap text-ellipsis overflow-hidden text-center text-md leading-normal font-medium text-secondary">
                    (organization primary contact)
                </div>
                <div *ngIf="workingGroups.length > 0" id="user-working-groups" class="w-full mt-10">
                    <div class="text-center text-sm font-semibold uppercase tracking-wider text-secondary">My Working Groups</div>
                    <ul class="flex flex-wrap justify-center gap-2 mt-3 p-0">
                        <li *ngFor="let group of workingGroups" class="px-3 py-0.5 rounded-full bg-white/10 border border-white/25 text-sm font-medium leading-normal">{{group}}</li>
                    </ul>
                </div>
            </div>
            <div class="relative w-24 h-18"></div>
        </div>
    </ng-container>
    <!-- Navigation footer hook -->
    <ng-container fuseVerticalNavigationContentFooter>
        <!-- <div class="flex flex-0 items-center justify-center h-16 pr-6 pl-2 mt-2 mb-4 opacity-12">
            <img
                class="max-w-36"
                src="assets/images/logo/logo-text-on-dark.svg">
        </div> -->
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div id="navigation-bar" class="relative flex flex-0 items-center w-full px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <!-- Navigation toggle button -->
        <button
            mat-icon-button
            (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
        <div class="navMenuItem" (click)="navigateTo('/')">Home</div>

        <div class="navMenuItem" (click)="navigateTo('/new-members')">New Members</div>
        <div class="navMenuItem" *ngIf="canViewSolicitations()" (click)="navigateTo('/solicitations')">Solicitations</div>
        <div class="navMenuItem" (click)="navigateTo('/working-groups')">Working Groups</div>

        <div class="navMenuItem" (click)="navigateTo('/resources')">Resources</div>
        <div class="navMenuItem" (click)="navigateTo('https://www.nationalspectrumconsortium.org/news')">News & Events</div>
        <div id="follow-us" class="navMenuItem" (click)="navigateTo('/social-media')">Follow Us</div>
    </div>

    <!-- Page banner -->
    <page-banner
        *ngIf="bannerHeading"
        [heading]="bannerHeading"></page-banner>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer: the consortium's export-control notice, on every signed-in page (NSCDEV-175).
         Its wording is theirs; the certification that follows it is the solicitation dialog. -->
    <div id="compliance-notice" class="relative flex flex-0 items-center w-full px-4 md:px-6 py-3 z-49 border-t bg-card dark:bg-transparent">
        <span class="text-sm text-secondary">
            Files available on this secure portal may contain ITAR-controlled technical data or
            defense articles, EAR-controlled technology or software, and/or CUI.
        </span>
    </div>

</div>
